module.exports = __webpack_public_path__ + "static/media/akal_logo.0cef409c.svg";